const colors = [
    "#818cf8",
    "#a78bfa",
    "#8b5cf6",
    "#fecdd3",
    "#f0abfc",
    "#fda4af",
    "#c4b5fd",
    "#a5b4fc",
    "#c084fc",
    "#a78bfa"
];

export default colors